
import 'raf/polyfill'
import 'babel-polyfill'
import axios from 'axios'

const USER_LIST = 'USER_LIST'
const UN_READ = 'UN_READ'
const INFO_MSG = 'INFO_MSG'
const REDUCE_UN_READ = 'REDUCE_UN_READ'
const BG_URL = 'BG_URL'
const AUTHEN_DATA = 'AUTHEN_DATA'
const AUTHEN_MSG ='AUTHEN_GRADE'
const GET_GIFT_SUCCESS = 'GET_GIFT_SUCCESS'
const initState = {
	userlist:{},
	showLogin:true,
	msgClass:'',
	inputUserId:'',
	inFoMsg:'',
	unRead:'',
	authentication:'',
	getGiftSuccessData:''

}

export function chatuser(state=initState, action){
	switch(action.type){
		case USER_LIST:
			return {
				...state,
				userlist: action.payload,
				showLogin: action.show
			}
		case UN_READ:
			return {
				...state, 
				unRead:action.payload,
				msgClass:action.msgClass
			}
		case REDUCE_UN_READ:
			return{
				...state, 
				unRead:state.unRead-1,
				msgClass:action.msgClass

			}
		case INFO_MSG:
			return {
				...state, 
				
				inFoMsg:action.payload
			}
		case BG_URL:
			return{
				...state, 
				
				bigBg:action.payload
			}
		case AUTHEN_DATA:
		 	return{
		 		...state,
		 		authentication:action.payload
		 	}
		 case AUTHEN_MSG:
		 	return {
		 		...state,
		 		authenMsgData:action.payload
		 	}
		 case GET_GIFT_SUCCESS:
		 	return{
		 		...state,
		 		getGiftSuccessData:action.payload
		 	}

		default:
			return state
	}
}

export function userList(data){
	var showLogin = true
	if(data.code===-1){
		showLogin=false
	}
	return { type:USER_LIST, payload:data,show:showLogin}
}

 function inFoFn (data){
	
	return { type:INFO_MSG, payload:data}
}
export function getBigBGUrl(data) {
	
	return { type:BG_URL, payload:data}
}
export function getInFoFn(){

	return dispatch=>{
		axios.get('/fapi/user/info')
			.then(res=>{
				
				if(res.data.return_code==0){
					
					dispatch(inFoFn(res.data.data))
				}
				
		})
	}
		
}



function UnReadNum(data,iCls){
	return { type:UN_READ, payload:data,msgClass:iCls}
}

export function authenticationFn(data){
	
	return { type:AUTHEN_DATA, payload:data}
}
export function reduceMsgNum(){
	
	return { type:REDUCE_UN_READ}
}


export function getUnReadNum() {
	return dispatch=>{
		axios.get('/fapi/notices/unreadCount')
	      .then(res=>{
	        
				
				dispatch(UnReadNum(res.data.list_count,'message-ac-icon'))
	       
	     
	 	}) 
 	} 
}
export function getAuthentication(_data) {
	return dispatch=>{
		axios.get('/fapi/recom/authentication?account='+_data)
	      .then(res=>{
	        				
				dispatch(authenticationFn(res.data))
	      	     
	 	}) 
 	} 
}
export function authenMsg(data){
	return { type:AUTHEN_MSG, payload:data}
}

export function getGiftSuccessCallBack(data){
	return { type:GET_GIFT_SUCCESS, payload:data}
}

/*
export function getBigBG(){
    return dispatch=>{
    	 axios.get('/fapi/getAdvPics?kind=2')
	        .then((res)=>{
	            if(res.data.return_code===0){
	                var str = 
	                str=res.data.imghost+res.data.data.imgurl
	                dispatch(getBigBGUrl(str))
	                
	                
	            }
	            
	        })
    }
   

}
*/



// WEBPACK FOOTER //
// ./src/redux/chatuser.redux.js